var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.has_match_page_store
    ? _c(
        "div",
        {
          class: [
            "fg-container roi-component",
            { "waf-menu-card": _vm.activeModule === "GAME_PLAN" },
            { "waf-lineup": _vm.activeModule === "LINEUP" },
            {
              "waf-match-info":
                _vm.activeModule === "MATCH_INFO" ||
                _vm.activeModule === "MATCH_INFO_AMP",
            },
            { "waf-scorecard": _vm.activeModule === "SCORECARD" },
          ],
        },
        [
          !_vm.isLoading
            ? _c("top-section", {
                attrs: {
                  isAmp: _vm.isAmp,
                  parentRoute: _vm.parentRoute,
                  loaded_module: _vm.loaded_module,
                  breadcrumbTransKey: _vm.getBreadcrumbTrans(),
                },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeModule === "GAME_PLAN"
            ? _c("contest-parent", { attrs: { parentRoute: _vm.parentRoute } })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeModule === "LINEUP"
            ? _c("teams-parent", { attrs: { parentRoute: _vm.parentRoute } })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeModule === "MATCH_INFO"
            ? _c("fantasy-tips-parent", {
                attrs: { parentRoute: _vm.parentRoute },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeModule === "MATCH_INFO_AMP"
            ? _c("amp-fantasy-tips-parent", {
                attrs: { parentRoute: _vm.parentRoute },
              })
            : _vm._e(),
          _vm._v(" "),
          _vm.activeModule === "SCORECARD"
            ? _c("scorecard-parent", {
                attrs: { parentRoute: _vm.parentRoute },
              })
            : _vm._e(),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }